import classNames from 'classnames';
import React, { MouseEvent, useCallback, useState, KeyboardEvent } from 'react';
import { Button } from '../controls';
import { RawFieldRenderer } from '../field-renderers';
import { createField } from '../helpers';
import { FieldProps, IconName } from '../types';
import InputTextField from './InputTextField';

interface FFProps extends FieldProps<string, HTMLInputElement> {
    title?: string;
    /** Placeholder of the text field */
    placeholder?: string;
    textApply?: string;
    iconApply?: IconName;
    textClear?: string;
    iconClear?: IconName;
    btnApply?: string;
    btnClear?: string;
}

/**
 * Text field whose values are changed when a button is clicked.
 */
const ButtonInputTextField = createField<
    string,
    HTMLDivElement,
    FFProps
>((props) => {
    const [prevValue, setPrevValue] = useState(props.value);
    const [value, setValue] = useState(props.value);

    const handleApply = useCallback((e: MouseEvent<HTMLButtonElement>) => {
        setPrevValue(value);
        props.onValueChange(value, prevValue, props.name, e);
    }, [props.onValueChange, value, prevValue, props.name]);

    const handleClear = useCallback((e: MouseEvent<HTMLButtonElement>) => {
        setPrevValue(value);
        setValue('');
        props.onValueChange('', prevValue, props.name, e);
    }, [props.onValueChange, value, prevValue, props.name]);

    const handleKeyPress = useCallback((e: KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.stopPropagation();
            setPrevValue(value);
            props.onValueChange(value, prevValue, props.name, e);
        }
    }, [props.onValueChange, value, prevValue, props.name]);

    return <div className={classNames(props.className, 'input-group')}>
        <InputTextField
            value={value}
            onValueChange={setValue}
            Renderer={RawFieldRenderer}
            name={props.name}
            placeholder={props.placeholder}
            disabled={props.disabled}
            title={props.title}
            onKeyPress={handleKeyPress}
        />
        <span className="input-group-btn">
            <Button
                btn={props.btnApply}
                disabled={props.disabled}
                icon={props.iconApply}
                onClick={handleApply}
                text={props.textApply}
                title={props.title}
                type="button"
            />
        </span>
        <span className="input-group-btn">
            <Button
                btn={props.btnClear}
                disabled={props.disabled}
                icon={props.iconClear}
                onClick={handleClear}
                text={props.textClear}
                title={props.title}
                type="button"
            />
        </span>
    </div>;
});

export default ButtonInputTextField;
